import { render, staticRenderFns } from "./addChiefWaiter.vue?vue&type=template&id=efb99c9c&scoped=true&"
import script from "./addChiefWaiter.vue?vue&type=script&lang=js&"
export * from "./addChiefWaiter.vue?vue&type=script&lang=js&"
import style0 from "./addChiefWaiter.vue?vue&type=style&index=0&id=efb99c9c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb99c9c",
  null
  
)

export default component.exports